import { useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { ActionCreators } from "../../redux/AdministrateurDeBien";
import Api, { IApi } from "../../services/Api";
import { ActionCreators as AdbActionCreators } from "../../redux/AdministrateurDeBien";
import {
  AdministrateurBien,
  AdministrateurBienDetail,
  AdministrateurBienList,
  HabilitationsAdb,
} from "../../services/Api/swagger";
import { getApiEndpoint } from "../../services/Config";

export const useSearchAdministrateursdeBiens = () => {
  const api: IApi = Api.create(getApiEndpoint());

  const dispatch = useDispatch();
  return useMutation<AdministrateurBienList, any, any>(
    // @ts-ignore
    (params) => api?.getAllAdministrateursDeBiens(params),
    {
      onSuccess: (data) => {
        dispatch(ActionCreators.search.success(data));
      },
      onError: (error) => {
        dispatch(ActionCreators.search.failure(error));
      },
    },
  );
};

// export function* searchAdministrateursDeBiens(
//   api: IApi,
//   action: ActionType<typeof ActionCreators.search.request>,
// ) {
//   try {
//     const result: AdministrateurBienList = yield call(
//       api.getAllAdministrateursDeBiens,
//       action.payload,
//     );
//     yield put(ActionCreators.search.success(result));
//   } catch (error) {
//     yield put(ActionCreators.search.failure(error));
//   }
// }

export const useGetAdbRegroupement = () => {
  const api: IApi = Api.create(getApiEndpoint());

  const dispatch = useDispatch();
  return useMutation<AdministrateurBien[], any, any>(
    // @ts-ignore
    (params) => api?.getAdbRegroupement(params),
    {
      onSuccess: (data) => {
        dispatch(ActionCreators.getADBRegroupement.success(data));
      },
      onError: (error) => {
        dispatch(ActionCreators.getADBRegroupement.failure(error));
      },
    },
  );
};

export const useGetAdbDetail = () => {
  const api: IApi = Api.create(getApiEndpoint());

  const dispatch = useDispatch();
  return useMutation<AdministrateurBienDetail, any, any>(
    // @ts-ignore
    (params) => api?.getAdbIdDetail(params),
    {
      onSuccess: (data) => {
        dispatch(ActionCreators.getADBIdDetail.success(data));
      },
      onError: (error) => {
        dispatch(ActionCreators.getADBIdDetail.failure(error));
      },
    },
  );
};

export const useGetAdbDetailForUserForm = () => {
  const api: IApi = Api.create(getApiEndpoint());

  return useMutation<AdministrateurBienDetail, any, any>(
    // @ts-ignore
    (params) => api?.getAdbIdDetail(params),
    {},
  );
};

export const useActiverAdb = () => {
  const api: IApi = Api.create(getApiEndpoint());

  const navigate = useNavigate();
  const dispatch = useDispatch();
  return useMutation<AdministrateurBienDetail, any, any>(
    // @ts-ignore
    (params) => api?.activerAdb(params),
    {
      onSuccess: (data) => {
        dispatch(ActionCreators.activerAdb.success(data));
        // navigate("/mes-administrateurs-de-biens/consulter");
      },
    },
  );
};

export const useDesactiverAdb = () => {
  const api: IApi = Api.create(getApiEndpoint());

  const dispatch = useDispatch();
  return useMutation<AdministrateurBienDetail, any, any>(
    // @ts-ignore
    (params) => api?.desactiverAdb(params),
    {
      onSuccess: (data) => {
        dispatch(ActionCreators.desactiverAdb.success(data));
      },
    },
  );
};

export const usePatchAdb = () => {
  const api: IApi = Api.create(getApiEndpoint());

  const dispatch = useDispatch();
  const { mutate: mutateADBIdDetail } = useGetAdbDetail();
  return useMutation<
    void,
    any,
    {
      id: number;
      habilitations: HabilitationsAdb;
    }
  >(
    // @ts-ignore
    (params) => api?.patchAdb(params),
    {
      onSuccess: (data, variables) => {
        mutateADBIdDetail(variables.id);
        dispatch(AdbActionCreators.updateAdbId(variables.id));
      },
    },
  );
};
